import React, { useEffect, useState } from "react";
import { Card, Flex, Button, Tag, Checkbox, Progress, Typography } from 'antd';
import "./RecipeCard.css";
import { BookOutlined, ClockCircleOutlined } from '@ant-design/icons';
import common_axios from "./../../commonAxios";

const { Link, Text } = Typography;

const RecipeCard = (props) => {
    const [craftedAmount, setCraftedAmount] = useState(props.data.craftedAmount);
    const [failedAmount, setFailedAmount] = useState(props.data.failedAmount);
    const [learningProgress, setLearningProgress] = useState(props.data.learningProgress);
    const [learned, setLearned] = useState(props.data.learned);

    const craftSuccess = () => {
        common_axios.put(`${process.env.REACT_APP_API_URL}/RecipeToUser/success/`, {
            recipeToUserId: props.data.id,
            recipeId: props.data.recipeId.id,
            userId: props.data.userId.id
        }).then(response => {
            setCraftedAmount(craftedAmount + 1);
            window.location.reload(false);
        })
    }

    const craftFailIngredientsSaved = (num) => {
        common_axios.put(`${process.env.REACT_APP_API_URL}/RecipeToUser/failsave/`, {
            recipeToUserId: props.data.id,
            recipeId: props.data.recipeId.id,
            userId: props.data.userId.id
        }).then(response => {
            setFailedAmount(failedAmount + 1);
            window.location.reload(false);
        })
    }

    const craftFailIngredientsLost = (num) => {
        common_axios.put(`${process.env.REACT_APP_API_URL}/RecipeToUser/faillost/`, {
            recipeToUserId: props.data.id,
            recipeId: props.data.recipeId.id,
            userId: props.data.userId.id
        }).then(response => {
            setFailedAmount(failedAmount + 1);
            window.location.reload(false);
        })
    }

    const addLearningProgress = () => {
        common_axios.put(`${process.env.REACT_APP_API_URL}/RecipeToUser/addHour/`, {
            recipeToUserId: props.data.id
        }).then(response => {
            if (learningProgress >= props.data.recipeId.learningHours - 1) {
                setLearned(true);
            }
            setLearningProgress(learningProgress + 1);
        })
    }

    const uncraftableClassName = () => {
        if (props.data.craftable) {
            return "craftable";
        }
        return "uncraftable";
    }

    const favPotionClassName = () => {
        console.log(props.data);
        return props.data.favouritePotion ? "fav" : "";
    }

    const cardBoxLearnedClassNames = () => {
        let classNames = [3];
        classNames[0] = "cardBoxLearned";
        classNames[1] = uncraftableClassName();
        classNames[2] = favPotionClassName();
        return classNames;
    }

    const cardBoxNotLearnedClassNames = () => {
        let classNames = [2];
        classNames[0] = "cardBoxNotLearned";
        classNames[1] = favPotionClassName();
        return classNames;
    }

    return (
        <div>
            {learned &&
                <div className={cardBoxLearnedClassNames().join(' ')}>
                    <div>
                        <div className="nameRecipe">{props.data.recipeId.name} <BookOutlined className="learned" /></div>
                    </div>
                    <div className="bodyCard">
                        <Flex justify="center" gap={50} className="cardInfo">
                            <div className="learnDC">DC: {props.data.recipeId.dc}</div>
                            <div className="recipe">{props.data.recipeId.recipe.replace(',', '\n')}</div>
                            <div className="craftHours"><ClockCircleOutlined /> {props.data.recipeId.craftingHours}h</div>
                        </Flex>
                        <Flex justify="center" gap="small">
                            <Button className="buttonSuccess" variant="filled" onClick={craftSuccess} disabled={!props.data.craftable}>
                                Success
                            </Button>
                            <Button className="buttonFailSave" variant="filled" onClick={craftFailIngredientsSaved} disabled={!props.data.craftable}>
                                Fail (Ingredients saved)
                            </Button>
                            <Button className="buttonFailLost" variant="filled" onClick={craftFailIngredientsLost} disabled={!props.data.craftable}>
                                Fail
                            </Button>
                        </Flex>
                    </div>
                </div>
            }
            {!learned &&
                <div className={cardBoxNotLearnedClassNames().join(' ')}>
                    <div>
                        <div className="nameRecipe">{props.data.recipeId.name}</div>
                    </div>
                    <div className="bodyCard">
                        <Flex justify="center" gap={50} className="cardInfo">
                            <div className="recipe">{props.data.recipeId.recipe.replace(",", "\n")}</div>
                            <div className="learnDC">DC: {props.data.recipeId.dc}</div>
                            <div className="learnHours"><ClockCircleOutlined /> {props.data.recipeId.learningHours}h</div>
                        </Flex>
                        <Flex>
                            <Progress
                                className="progress"
                                percent={learningProgress / props.data.recipeId.learningHours * 100}
                                steps={{
                                    count: props.data.recipeId.learningHours,
                                    gap: 1,
                                }}
                                trailColor="rgba(0, 0, 0, 0.06)"
                                strokeWidth={20}
                                format={(percent) => `${learningProgress} / ${props.data.recipeId.learningHours}h`}
                            />
                            <Button className="buttonLearn" color="green" variant="filled" onClick={addLearningProgress}>
                                Add 1 Hour
                            </Button>
                        </Flex>
                    </div>
                </div>
            }
        </div>
    );
};

export default RecipeCard;